export default __webpack_public_path__ + "static/media/prosespembuatan.c468d6be.webp";